import React from 'react';

import ApartmentSVG from '@/Components/SVG/ApartmentSVG';
import EventSVG from '@/Components/SVG/EventSVG';
import BookmarkSVG from '@/Components/SVG/BookmarkSVG';
import DownloadSVG from '@/Components/SVG/DownloadSVG';

interface SideLoginProps {
    pc?: boolean;
    sp?: boolean;
}

const SideLogin: React.FC<SideLoginProps> = ({ pc, sp }) => {
    const content = (
        <>
            <p>内見予約ナビで出来ること</p>
            <span>
                <i>
                    <ApartmentSVG />
                </i>
                物件確認
            </span>
            <span>
                <i>
                    <EventSVG />
                </i>
                内見予約
            </span>
            <span>
                <i>
                    <BookmarkSVG />
                </i>
                広告承諾申請
            </span>
            <span>
                <i>
                    <DownloadSVG />
                </i>
                資料ダウンロード
            </span>
        </>
    );
    return (
        <>
            {pc && (
                <div className="login-index__aside pc" aria-hidden={!pc}>
                    {content}
                </div>
            )}
            {sp && (
                <div className="login-index__aside sp" aria-hidden={!sp}>
                    {content}
                </div>
            )}
        </>
    );
};

export default SideLogin;
